module.exports = __webpack_public_path__ + "media/images/icon__point--default@3x-7ea5f993e30b9882a218076b8ead6935.png";